// extracted by mini-css-extract-plugin
export default {"aiBubbleContent":"aiBubbleContent___xnsmD"};